"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionContents = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../../styles");
var Content_1 = require("./Content");
var Section = styled_components_1.default.section(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  grid-column: 1 / span 6;\n  ", "\n\n  ", "\n\n  > article {\n    &.media {\n      width: 100%;\n    }\n\n    &.text {\n      ", "\n    }\n  }\n\n  .spacer {\n    height: ", ";\n\n    ", "\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  grid-column: 1 / span 6;\n  ", "\n\n  ", "\n\n  > article {\n    &.media {\n      width: 100%;\n    }\n\n    &.text {\n      ", "\n    }\n  }\n\n  .spacer {\n    height: ", ";\n\n    ", "\n  }\n"])), (0, styles_1.getMargin60)(), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    grid-column: 3 / span 8;\n  "], ["\n    grid-column: 3 / span 8;\n  "]))), styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        padding: 0 ", ";\n      "], ["\n        padding: 0 ", ";\n      "])), function (_a) {
    var col = _a.theme.col;
    return (0, styles_1.getRelative)(col.desktop, 'desktop');
}), (0, styles_1.getRelative)(40, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), (0, styles_1.getRelative)(50, 'desktop')));
var getContentsByColumns = function (columns) { return columns.map(function (content, idx) {
    return ((0, jsx_runtime_1.jsx)(Content_1.Content, { content: content }, idx + 'column'));
}); };
exports.SectionContents = (0, react_1.memo)(function (_a) {
    var section = _a.section, _b = _a.className, className = _b === void 0 ? '' : _b;
    var columns = section.columns;
    var ContentsByColumns = (0, react_1.useMemo)(function () { return getContentsByColumns(columns); }, [columns]);
    return ((0, jsx_runtime_1.jsx)(Section, __assign({ className: className }, { children: ContentsByColumns })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
